import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {QUERY_KEYS} from '../../../queryClient'
import {
    DashboardAnalyticsResponse,
    httpGetDashboardAnalytics,
    HttpGetDashboardAnalyticsOptions
} from '../http/dashboard.http'

export const useGetDashboardAnalytics = (
    params: HttpGetDashboardAnalyticsOptions['params'],
    options?: Omit<UseQueryOptions<DashboardAnalyticsResponse>, 'queryKey' | 'queryFn'>
) => {
    return useQuery({
        queryKey: [QUERY_KEYS.DASHBOARD_ANALYTICS, params],
        queryFn: () => httpGetDashboardAnalytics({params}),
        ...options
    })
}
